import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root',
})
export class NotificacionService {
	constructor(private _apiService: ApiService) {}

	/* GET */
	getNotificacionesActivas() {
		return this._apiService.get(`/public/notificacionesActivas`);
	}
}
